import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { breadcrumbsPropTypes } from '../../../common/resource/proptypes/CommonPropTypes';
import FuelDataCompletenessReportSearchForm from './FuelDataCompletenessReportSearchForm';
import { FUEL_DATA_COMPLETENESS_REPORT_PATH } from '../../../../config/paths';
import {
  clearFuelDataCompletenessReport,
  postFuelDataCompletenessReport,
} from '../../../../actions';
import FuelDataCompletenessReportSearchResult from './FuelDataCompletenessReportSearchResult';
import { tzNormalizeDate } from '../../../../utils/date';
import { TIMESTAMP_FORMAT } from '../../../../config/locale';
import Content from '../../../layout/Content';

export class FuelDataCompletenessReport extends Component {
  componentWillUnmount() {
    this.props.dispatchClearFuelDataCompletenessReport();
  }

  onSubmit = (formValues) => {
    const payload = {
      fromDate: tzNormalizeDate({
        date: formValues.fromDate,
        format: TIMESTAMP_FORMAT,
        time: 'start',
      }),
      toDate: tzNormalizeDate({
        date: formValues.toDate,
        format: TIMESTAMP_FORMAT,
        time: 'end',
      }),
    };

    if (formValues.registeredBusId && formValues.registeredBusId.length) {
      payload.companyBusIds = formValues.registeredBusId.map(({ label }) =>
        String(label),
      );
    }

    if (
      formValues.circuitId !== undefined &&
      formValues.circuitId !== null &&
      formValues.circuitId !== ''
    ) {
      payload.circuitId = formValues.circuitId;
    }
    if (formValues.circuitTypes && formValues.circuitTypes.length > 0) {
      payload.circuitTypes = formValues.circuitTypes;
    }
    if (formValues.includeNorthChicoRoutes) {
      payload.includeNorthChicoRoutes = true;
    }

    this.props.dispatchPostFuelDataCompletenessReport(payload);
  };

  render() {
    const { breadcrumbs } = this.props;

    const subtitle = (
      <span>
        Filtra por <strong>fecha de salida del itinerario</strong>. Opcionalmente por{' '}
        <strong>bus</strong>, <strong>circuito del itinerario</strong> y{' '}
        <strong>tipo de circuito</strong> (simple/compuesto). Por defecto no se listan rutas{' '}
        <strong>Norte Chico</strong>; puedes incluirlas con la opción del formulario. Las alertas
        muestran datos no registrados necesarios para el control de combustible.
      </span>
    );

    const content = (
      <Fragment>
        <FuelDataCompletenessReportSearchForm onSubmit={this.onSubmit} />
        <FuelDataCompletenessReportSearchResult />
      </Fragment>
    );

    return (
      <Content
        breadcrumbs={breadcrumbs}
        title="Reporte de Seguimiento de Combustible"
        subtitle={subtitle}
        content={content}
      />
    );
  }
}

const mapStateToProps = ({ TrafficUnit }) => ({
  breadcrumbs: [
    ...TrafficUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Reporte de Seguimiento de Combustible',
      href: FUEL_DATA_COMPLETENESS_REPORT_PATH,
    },
  ],
});

const mapDispatchToProps = {
  dispatchPostFuelDataCompletenessReport: postFuelDataCompletenessReport,
  dispatchClearFuelDataCompletenessReport: clearFuelDataCompletenessReport,
};

FuelDataCompletenessReport.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  dispatchPostFuelDataCompletenessReport: PropTypes.func.isRequired,
  dispatchClearFuelDataCompletenessReport: PropTypes.func.isRequired,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(FuelDataCompletenessReport);
